export const linkFirstAccountData = [
  {
    Question: `How can I link up my first WM account?`,
    Answer: `  1. Login to MyWM  
        2. Scroll down  
        3. Out in your Customer ID and other information to link your account! 
  
   Note: Make sure you are signed in to the correct account before attempting to link another account. Visit our webpage for a video tutorial.`,
  },
]
